<template>
  <div class="home">
    <Navigation />
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";

export default {
  name: "Notifications",
  components: {
    Navigation
  }
};
</script>

<style lang="scss" scoped src="@/styles/style-home.scss">
